import { render, staticRenderFns } from "./SceneOrder.vue?vue&type=template&id=2a6d7dc8&scoped=true&"
import script from "./SceneOrder.vue?vue&type=script&lang=js&"
export * from "./SceneOrder.vue?vue&type=script&lang=js&"
import style0 from "./SceneOrder.vue?vue&type=style&index=0&id=2a6d7dc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d7dc8",
  null
  
)

export default component.exports